// @ts-nocheck
import React, { useMemo } from 'react';
import { Grid, TextField, Tooltip, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import {
  checkAttributeIsRequired,
  getErrorHelperText,
} from '../../../../utils/Utils';

/**
 * Text field component for editing text attributes
 * @param {Object} props - Component props
 * @param {string} props.label - Field label
 * @param {string|number} props.value - Current field value
 * @param {Function} props.onChange - Function to handle value changes
 * @returns {React.ReactElement} The TextField component
 */
const ParagraphFieldRenderer = ({
  value,
  attribute,
  entityDetailsFormikForm,
  label,
}) => {
  /**
   * Handles input change events
   * @function
   * @param {React.ChangeEvent<HTMLInputElement>} e - The change event
   * @returns {void}
   */

  const isAttributeMandatory = useMemo(() => {
    return checkAttributeIsRequired(attribute);
  }, [attribute]);

  return (
    <Grid gap={2} container xs={12}>
      <Grid item xs={12}>
        <TextField
          required={isAttributeMandatory}
          label={label}
          fullWidth
          {...entityDetailsFormikForm?.getFieldProps(`${attribute?.id}.title`)}
          placeholder="Enter a title"
          spellCheck
          type="text"
          inputProps={{
            title: value?.title || '',
          }}
          error={Boolean(
            getErrorHelperText(
              entityDetailsFormikForm?.errors[attribute?.id]?.title,
              entityDetailsFormikForm?.touched[attribute?.id]?.title
            )
          )}
          helperText={getErrorHelperText(
            entityDetailsFormikForm?.errors[attribute?.id]?.title,
            entityDetailsFormikForm?.touched[attribute?.id]?.title
          )}
          disabled={!attribute?.is_editable}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          required={isAttributeMandatory}
          label={
            <Tooltip title={attribute?.justification_label}>
              <Typography
                variant="body4"
                sx={{
                  display: 'inline-block',
                  maxWidth: '340px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  verticalAlign: 'middle',
                }}
              >
                {attribute?.justification_label}
              </Typography>
            </Tooltip>
          }
          {...entityDetailsFormikForm?.getFieldProps(
            `${attribute?.id}.description`
          )}
          placeholder="Enter a description"
          multiline
          minRows={4}
          spellCheck
          inputProps={{ title: value?.description || '' }}
          error={Boolean(
            getErrorHelperText(
              entityDetailsFormikForm?.errors[attribute?.id]?.description,
              entityDetailsFormikForm?.touched[attribute?.id]?.description
            )
          )}
          helperText={getErrorHelperText(
            entityDetailsFormikForm?.errors[attribute?.id]?.description,
            entityDetailsFormikForm?.touched[attribute?.id]?.description
          )}
          disabled={!attribute?.is_editable}
        />
      </Grid>
    </Grid>
  );
};

ParagraphFieldRenderer.propTypes = {
  value: PropTypes.string,
  attribute: PropTypes.shape({
    is_editable: PropTypes.bool,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    justification_label: PropTypes.string,
  }).isRequired,
  entityDetailsFormikForm: PropTypes.shape({
    getFieldProps: PropTypes.func.isRequired,
    errors: PropTypes.objectOf(PropTypes.string).isRequired,
    touched: PropTypes.objectOf(PropTypes.bool).isRequired,
  }).isRequired,
  label: PropTypes.string.isRequired,
};

export default ParagraphFieldRenderer;
